/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
/**
 * `entities/tracker-comment` TanStack Query key factory. `all` for namespace
 * invalidation, `list(trackerId, rowKey)` for one board row's flat comment
 * thread (ordered ascending by `createdAt`, as the backend emits).
 */
export const TRACKER_COMMENT_QUERY_KEYS = {
  all: ['tracker-comments'] as const,
  list: (trackerId: string, rowKey: string) =>
    [...TRACKER_COMMENT_QUERY_KEYS.all, 'list', trackerId, rowKey] as const,
  /** One entry per board — per-row counts for all the badges (a single fetch). */
  summary: (trackerId: string) =>
    [...TRACKER_COMMENT_QUERY_KEYS.all, 'summary', trackerId] as const,
} as const;
